// @ts-nocheck
import { COMBINATION_LOCK_LIST_RECEIVED, COMBINATION_LOCK_ITEM_RECEIVED } from '../types';
import CombinationLockService from '../../services/CombinationLockService';
import { setPagination } from './pagination';
import { PAGINATION_KEYS } from '../../utils/constants';
import { changeTicketInfoModalProps } from './global';

export const getCombinationLockList = params => async (dispatch, getStore) => {
    dispatch(setPagination(PAGINATION_KEYS.combinationLocks, { isFetching: true }));

    const data = await CombinationLockService.getCombinationLockList(params);
    if (data?.items) {
        const receivedCombinations = data.items;

        const store = getStore();
        const currentCombinations = store.combinationLock.list;

        let newCombinations;

        if (params.index > 0) {
            newCombinations = currentCombinations.concat(receivedCombinations);
        } else {
            newCombinations = receivedCombinations;
        }

        const hasMore = receivedCombinations.length >= params.size;
        dispatch(
            setPagination(PAGINATION_KEYS.combinationLocks, {
                page: params.index,
                size: params.size,
                hasMore,
                isFetching: false,
            })
        );

        dispatch(setCombinationLockList(newCombinations));
    }

    dispatch(setPagination(PAGINATION_KEYS.combinationLocks, { isFetching: false }));
};

export const setCombinationLockList = list => ({
    type: COMBINATION_LOCK_LIST_RECEIVED,
    payload: list,
});

export const getCombinationLockItem = id => async dispatch => {
    const data = await CombinationLockService.getCombinationLockItem(id);
    if (data?.item) {
        dispatch(setCombinationLockItem(data.item));
    }
};

export const setCombinationLockItem = payload => ({
    type: COMBINATION_LOCK_ITEM_RECEIVED,
    payload,
});

export const clearCombinationLockItem = () => ({
    type: COMBINATION_LOCK_ITEM_RECEIVED,
    payload: null,
});

export const toggleCombinationLockItem = (id, isLocked, params) => async (dispatch, getStore) => {
    const { info, item } = isLocked
        ? await CombinationLockService.unlockCombinationLockItem(id, params)
        : await CombinationLockService.lockCombinationLockItem(id, params);

    if (info.success) {
        const store = getStore();
        const newCombinationList = store.combinationLock.list.map(combination =>
            combination.id === id ? item : combination
        );
        dispatch(setCombinationLockList(newCombinationList));
    }

    return { info };
};

export const toggleCombinationLockItemByTicket = params => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { ticket } = reduxStore.global.ticketInfoModalProps;

    const newParams = {
        ...params,
        channel: ticket.channel,
        ticketId: ticket.betId,
    };

    const { info, item } = ticket.isLocked
        ? await CombinationLockService.unlockCombinationLockItemByTicket(newParams)
        : await CombinationLockService.lockCombinationLockItemByTicket(newParams);

    if (!info.success) return { info };

    const updatedTicket = {
        ...ticket,
        isLocked: !ticket.isLocked,
    };

    dispatch(
        changeTicketInfoModalProps({
            isVisible: true,
            ticket: updatedTicket,
        })
    );

    const combinations = reduxStore.combinationLock.list;
    if (ticket.combinationLockId && combinations.length) {
        const newCombinationList = combinations.map(combination =>
            combination.combinationUUID === ticket.combinationLockId ? item : combination
        );
        dispatch(setCombinationLockList(newCombinationList));
    }

    return { info, updatedTicket };
};

export const createCombinationLockItem = formData => async (dispatch, getStore) => {
    const { info, item } = await CombinationLockService.createCombinationLockItem(formData);

    if (info.success) {
        const store = getStore();
        const newCombinationList = [item, ...store.combinationLock.list];
        dispatch(setCombinationLockList(newCombinationList));

        const { page } = store.pagination[PAGINATION_KEYS.combinationLocks];
        dispatch(setPagination(PAGINATION_KEYS.combinationLocks, { page: page + 1 }));
    }

    return { info };
};

export const updateCombinationLockItem = (id, formData) => async (dispatch, getStore) => {
    const { info, item } = await CombinationLockService.updateCombinationLockItem(id, formData);

    if (info.success) {
        const store = getStore();
        const newCombinationList = store.combinationLock.list.map(combination =>
            combination.id === id ? item : combination
        );
        dispatch(setCombinationLockList(newCombinationList));
        dispatch(clearCombinationLockItem());
    }

    return { info };
};
